import React from 'react';
import { Button } from 'antd';
import { Icon as IconifyIcon } from '@iconify/react';

import { OrderService } from '../../../shared/services/OrderService';
import {
  isBackOfficeOrUpgasEmployee,
  isOrganization,
  isResale,
} from '../../../shared/services/UserService';
import OrderStatusEnum from '../../../shared/Enum/OrderStatusEnum';
import CpfGasDoPovoField from './CpfGasDoPovoField';

const CLOSED_STATUSES = [
  OrderStatusEnum.FinalizadoPeloMotorista,
  OrderStatusEnum.FinalizadoPelaOrganizacao,
  OrderStatusEnum.FinalizadoPeloAdm,
  OrderStatusEnum.FinalizadoPeloFuncionarioUpgas,
  OrderStatusEnum.FinalizadoPeloCliente,
  OrderStatusEnum.RejeitadoPeloMotorista,
  OrderStatusEnum.RejeitadoPelaOrganizacao,
  OrderStatusEnum.RejeitadoPeloAdm,
  OrderStatusEnum.RejeitadoPeloFuncionarioUpgas,
  OrderStatusEnum.CanceladoPeloMotorista,
  OrderStatusEnum.CanceladoPelaOrganizacao,
  OrderStatusEnum.CanceladoPeloCliente,
  OrderStatusEnum.CanceladoPorTempoExcedido,
  OrderStatusEnum.CanceladoPeloAdm,
  OrderStatusEnum.CanceladoPeloFuncionarioUpgas,
];

const ResumoDetalhePedido = ({ order, canShowSensitiveData, onShowMap }) => {
  const { statusId } = order;
  const addressWithoutNumber = (order.customer.address || '')
    .replace(/,\s*\d+(?:\s*[-/]\s*\d+)?(?:\s*[a-z])?(?=\s*(?:,|$))/i, '')
    .trim();

  const isAccepted =
    statusId === OrderStatusEnum.AceitoPeloMotorista ||
    statusId === OrderStatusEnum.AceitoPelaOrganizacao ||
    statusId === OrderStatusEnum.AceitoPeloAdm ||
    statusId === OrderStatusEnum.AceitoPeloFuncionarioUpgas;
  const isAdmin = isBackOfficeOrUpgasEmployee();
  const isClosed = CLOSED_STATUSES.includes(statusId);
  const canShowAddress =
    isAdmin ||
    isAccepted ||
    (isOrganization() && statusId === OrderStatusEnum.Solicitado);
  const cpfGasDoPovoDisponivel =
    order.gasDoPovo &&
    ((isAccepted && (isAdmin || isResale())) || (isClosed && isAdmin));

  return (
    <div className={`dp-info-card${order.gasDoPovo ? ' dp-info-card--gas-do-povo' : ''}`}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <span className='dp-info-card-title'>Informações do Cliente</span>
        {order.gasDoPovo && (
          <span className='dp-gas-do-povo-badge'>Gás do Povo</span>
        )}
        {canShowSensitiveData && (
          <Button
            size='small'
            type='link'
            style={{ padding: 0, fontSize: 16, height: 'auto' }}
            onClick={() => OrderService().copyToClipboard(order)}>
            Copiar pedido
          </Button>
        )}
      </div>

      <div>
        <div className='dp-info-card-name'>{order.customer.name}</div>
        <div className='dp-info-card-orders'>
          ({order.customer.totalOrders} pedidos)
        </div>
      </div>

      {canShowAddress && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:location-dot'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <span className='dp-info-card-row-text'>
            {canShowSensitiveData
              ? order.customer.address
              : addressWithoutNumber}

            {canShowSensitiveData && order.customer.complement && (
              <span>
                <br />
                {order.customer.complement}
              </span>
            )}
          </span>
        </div>
      )}

      {(order.customer.phone ||
        (isAdmin && order.customer.originalPhone)) && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:phone'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <span className='dp-info-card-row-link'>
            {canShowSensitiveData
              ? isAdmin
                ? order.customer.originalPhone
                : order.customer.phone
              : '•••••••••••'}
          </span>
        </div>
      )}

      {cpfGasDoPovoDisponivel && (
        <div className='dp-info-card-row dp-gas-do-povo-cpf'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:id-card'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <div className='dp-gas-do-povo-cpf__details'>
            <CpfGasDoPovoField orderId={order.id} />
          </div>
        </div>
      )}

      {order.customerFiscalNoteDocument !== '' && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-text'>
            CPF na nota: {order.customerFiscalNoteDocument}
          </span>
        </div>
      )}

      {order.codigoConfirmacao && isAdmin && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-text'>
            Código Confirmação: {order.codigoConfirmacao}
          </span>
        </div>
      )}

      {canShowSensitiveData && onShowMap && (
        <button type='button' className='dp-info-card-map-btn' onClick={onShowMap}>
          <IconifyIcon icon='fa6-solid:map' style={{ width: 14, height: 14 }} />
          Ver no Mapa
        </button>
      )}
    </div>
  );
};

export default ResumoDetalhePedido;
